import jSecure from "@linkedin/jsecure";
import scribdAuthorize from '../scribd/scribd_oauth.js';

(function($$, $) {
  // Dependencies
  var LoginTracker = $$.utils.imports('tracking.LoginTracker'),
      i18n = $$.utils.i18n;

  /**
   * Login constructor
   */
  function Login() {
    // GA Event category
    this.gaEventCategory = $$.is_mobile ? 'mobile_login' : 'Login';
    // Source URL
    this.fromSource = '';
    this.source = window.getUrlVar('from');

    // Tracking
    this.loginTracker = new LoginTracker();
    this.$linkedinButton = $('.j-linkedin-connect');
    this.$linkedinButton.attr('data-tracking-id', this.loginTracker.trackingId);
    this.$facebookButton = $('#fb-login');
    this.$facebookButton.attr('data-tracking-id', this.loginTracker.trackingId);
    this.$scribdButton = $("#scribd-login")
    this.$scribdButton.attr("data-tracking-id", this.loginTracker.trackingId)
  }

  /**
   * Login submit callback
   *
   * @param {Object} login form
   */
  Login.prototype.loginSubmit = function(form) {
    var username = form.find('#user_login').val();
    var password = form.find('#user_password').val();
    var formDataArray = form.serializeArray();
    var _this = this;

    if (username.length < 1 || password.length < 1 || username == "Username") {
      $('.j-alert').addClass('alert')
        .removeClass('success hide')
        .text(i18n('login_js.messages.all_fields_required'));
      return false;
    }
    $$.ga(_this.gaEventCategory, 'login_btn_login_page_clicked');
    $('.j-alert').addClass("hide");
    $('.j-button-submit-wrapper .j-button-label').addClass('hide');
    $('.j-button-submit-wrapper .j-loading').removeClass('hide');
    $('.j-button-submit-wrapper .ss-cta').prop('disabled', true);

    _this.loginTracker.trackSlideShareClick();
    formDataArray.push({
      name: 'tracking_id',
      value: _this.loginTracker.trackingId
    });

    $.post(
      form.attr("action"),
      formDataArray,
      function(data) {
        if (data.success) {
          if ($('#download_id').length > 0) {
            $$.ga(_this.gaEventCategory, 'ss_login', 'ss_login_from_login_download');
          } else {
            $$.ga(_this.gaEventCategory, 'ss_login', 'ss_login_from_login_page');
          }
          if (_this.fromSource &&
            _this.fromSource.length > 1 &&
            _this.fromSource !== "/" &&
            isInternalRedirect(_this.fromSource)) {
            window.location.href = decodeURIComponent(_this.fromSource);
          } else if (data.redirect_uri) {
            // This URL parameter forces the home page to skip the cache
            // and thus reflect the now logged-in state
            if (data.redirect_uri.search(/\?.*=/) > -1) {
              window.location = data.redirect_uri + "&loggedin=true";
            } else {
              window.location = data.redirect_uri + "?loggedin=true"
            }
          } else {
            window.location = '/?loggedin=true';
          }
        } else if (data.message) {
          $('.j-alert').addClass('alert')
            .removeClass("hide")
            .empty().append(jSecure.htmlEncode(data.message));
          $('.j-button-submit-wrapper .j-button-label').removeClass('hide');
          $('.j-button-submit-wrapper .j-loading').addClass('hide');
          $('.j-button-submit-wrapper .ss-cta').prop('disabled', false);
          _this.loginTracker._trackLoginError(JSON.stringify(data.message))

          // Reload recaptcha (since it works only for one request)
          grecaptcha.enterprise.reset();
        } else {
          window.location.reload();
        }
      },
      'json'
    ).fail(function(err) {
      $('.j-alert').addClass('alert')
        .removeClass("hide")
        .empty().append(jSecure.htmlEncode("Unexpected Error"));
      $('.j-button-submit-wrapper .j-button-label').removeClass('hide');
      $('.j-button-submit-wrapper .j-loading').addClass('hide');
      $('.j-button-submit-wrapper .ss-cta').prop('disabled', false);
      _this.loginTracker._trackLoginError(JSON.stringify(err));
    })
    ;
  };

  /**
   * Login initialization
   *
   * @param {String} login form id
   */
  Login.prototype.init = function(formId) {
    this.fromSource = window.getUrlVar('from_source', window.location.href) || '/';
    if ($('#user_login').val()) {
      $('#user_password').focus();
    }
    this.$form = $('#' + formId);

    this.loginTracker.trackLoginPageImpression(this.source);

    this.bindEvents();
  };

  /**
   * Event bindings
   *
   * @param {Object} login form
   */
  Login.prototype.bindEvents = function() {
    var _this = this;

    this.$form.on('submit', function() {
      _this.loginSubmit($(this));
    });

    this.$linkedinButton.on('click', function() {
      _this.loginTracker.trackLinkedinClick();
    });

    this.$facebookButton.on('click', function() {
      const facebookDisabled = window.feature_flags.disableFacebook;
      if (facebookDisabled) {
        $('#fb-login').addClass('disabled');
        $('#facebook-disabled-prompt').addClass('visible');
        _this.loginTracker.trackDisabledFacebookLogin();
      } else {
        _this.loginTracker.trackFacebookClick();
      }
    });

    this.$scribdButton.on("click", function () {
      _this.loginTracker.trackScribdClick()

      scribdAuthorize({ from_source: this.fromSource })
    })
  }

  /******************
   * Instantiate Login object and initialize
   */
  $(document).ready(function() {
    var login = new Login();
    login.init('login-form');
    $$.localizeForOtherLanguages();
  });

})(window.slideshare_object, jQuery);
